import { AuthService } from './_services/auth.service';

import Swal from 'sweetalert2';
import * as $ from "jquery";

declare var toastr: any;
declare var $:any;

export class Helpers {

    static setLoading(loading) {
        if (loading) {
            $('.preloader-backdrop').fadeIn(200);
        } else {
            $('.preloader-backdrop').fadeOut(200);
        }
    }

    static setBodyClasses() {

        if ($(this).width() < 767) $('body').addClass('drawer-sidebar');
        else $('body').removeClass('drawer-sidebar');

    }

    static closeShined() {

        $('body').removeClass('has-backdrop');
        $('.shined').removeClass('shined');

    }

    static bodyClass(Class) {
        $('body').attr('class', Class);
    }

    static initLayout() {

        // SIDEBAR TOGGLE ACTION
        $('.js-sidebar-toggler').click(function () {
            if( $('body').hasClass('drawer-sidebar') ) {
                $('.top-navbar').backdrop();
            } else {
                $('body').toggleClass('hidden-menu');
            }
        });

        // QUICK SIDEBAR TOGGLE ACTION
        $('.quick-sidebar-toggler').click(function(){
            $('.quick-sidebar').backdrop();
        });

        // SEARCH BAR ACTION
        $('.js-search-toggler').click(function() {
            $('.search-top-bar').backdrop().find('.search-input').focus();
        });
    }

    static initPage() {

        Helpers.closeShined();
        Helpers.setBodyClasses();

        // Activate Tooltips
        $('[data-toggle="tooltip"]').tooltip();

        // Activate slimscroll
        $('.scroller').each(function(){
            $(this).slimScroll({
                height: $(this).attr('data-height') || '100%',
                color: $(this).attr('data-color') || '#71808f',
                railOpacity: '0.9',
                size: '4px',
            });
        });

        $('.slimScrollBar').hide();

        // PANEL ACTIONS
        // ======================

        $('.ibox-collapse').click(function(){
            var ibox = $(this).closest('div.ibox');
            ibox.toggleClass('collapsed-mode').children('.ibox-body').slideToggle(200);
        });

    }

    static initTooltip(id, time) {

        setTimeout(function () {

            $(id).tooltip({
                trigger: 'hover'
            });

            $(id).click(function () {
                $(this).tooltip('hide');
            });

        }, time);

    }

    static initDatatable(datatableId, options, searchId) {

        if($(datatableId)) $(datatableId).DataTable().destroy();
        var table = $(datatableId).DataTable(options);

        if (searchId) {

            // Restore state text-search
            var state = table.state.loaded();
            if (state && state.search.search) {
                $(searchId).val(state.search.search);
            }

            $(searchId).on('keyup', function () {
                table.search(this.value).draw();
            });

        }

    }

    static initSummernote(id, height, time) {

        setTimeout(function () {

            $(id).summernote('destroy');
            $(id).summernote({
                disableDragAndDrop: true,
                height: height,
                toolbar: [
                    ['style', ['bold', 'italic', 'underline', 'clear']],
                    ['para', ['ul', 'ol']],
                ]
            });

        }, time);

    }

    static showToastr(type, msg) {

        toastr.options = {
            closeButton: true,
            newestOnTop: true,
            progressBar: false,
            positionClass: 'toast-bottom-left',
            onclick: null
        };

        var $toast = toastr[type](msg);

    }

    static initTab() {

        setTimeout(function () {

            $("[data-toggle='tab']").on("click", function () {

                var h = $(this).attr("href");
                $(".tab-pane:not('" + h + "')").removeClass("active");

            });

        }, 500);

    }

    static getFileExtension(filename: string) {
        return filename.substring(filename.lastIndexOf('.') + 1, filename.length) || filename;
    }

    static showModal(element, authService: AuthService = null, delay = 200) {

        // Se l'authService non � passato (opzionale), apri normalmente
        if (!authService) {
            this.executeOpen(element, delay);
            return;
        }

        // Se l'utente � loggato, facciamo un check preventivo
        if (authService.isTokenExpired()) {

            authService.refreshToken().subscribe(
                success => {
                    // Se il refresh ha successo (o il token era gi� ok), apri
                    this.executeOpen(element, delay);
                },
                error => {
                    // Se il refresh fallisce drasticamente, qui l'intercettore
                    // probabilmente ha gi� reindirizzato, ma per sicurezza
                    // evitiamo di aprire la modale "vuota" o rotta.
                    Swal({ title: "Session Expired", text: "Reconnect to continue", type: "warning" });
                }
            );

        } else {
            this.executeOpen(element, delay);
        }
    }

    private static executeOpen(element, delay) {

        setTimeout(() => {
            $(element).modal({ backdrop: 'static', keyboard: false });
        }, delay);

    }

    static hideModal(element, delay = 200) {

        setTimeout(() => {
            $(element).modal('hide');
        }, delay);

    }

    static initScroller(element, height) {

        $(element).slimScroll({
            height: height
        });

    }

    static initDentalPicker() {

    }

    static executeAfter(action, delay = 200) {

        setTimeout(() => {
            action();
        }, delay);

    }
}


// WEBPACK FOOTER //
// ./ClientApp/app/helpers.ts